import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import download from 'downloadjs';
import * as htmlToImage from 'html-to-image';
import moment from 'moment';
import defaultLogo from './../../../../images/logo/logo-80x50.png';

import EllipsisTooltip from '../../../common/EllipsisTooltip';

import './dashboard.css';

const teamColors = ["yellow", "turq", "blue", "purple", "green", "gray", "yellow", "turq", "blue", "purple", "green", "gray", "yellow", "turq", "blue", "purple", "green", "gray", "yellow", "turq", "blue", "purple", "green", "gray", "yellow", "turq", "blue", "purple", "green", "gray"];
const monthData = ["August", "September", "October", "November", "December", "January", "February", "March", "April", "May", "June", "July"];
const quarterData = ["Q1", "Q2", "Q3", "Q4"];
let eventsData;

class PrintViewPage extends React.Component {

    constructor(props) {
        super(props);
        this.tracksRef = React.createRef();

        this.state = {
            monthData: monthData,
            quarterData: quarterData,
            eventsData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
            openPresentModal: false
        };
    }

    componentWillUnmount() {
        dispatch.dashboards.openResourcePane(null);
        dispatch.dashboards.splitAt(null);

    }

    saveToImage = async () => {
        const target = document.getElementById("target");
        const documentName = this.props.selectedDashboard.name;

        const oldTargetStyle = target.style;
        target.style = 'width:3000px;';

        htmlToImage.toPng(target, {
            // quality: 0.25,
            filter: (elem) => {
                let includeElement = true;
                if (elem.tagName === 'BUTTON') {
                    includeElement = false;
                } else {
                    const data = elem.getAttribute ? elem.getAttribute("data-html2canvas-ignore") : null;
                    if (data) {
                        includeElement = false;
                    }
                }
                return includeElement;
            },
        })
            .then(function (dataUrl) {
                target.style = oldTargetStyle;
                //window.open().document.write('<img src="' + dataUrl + '"  alt=''/>');
                download(dataUrl, `${documentName}.png`);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    async componentDidMount() {
        await dispatch.dashboards.getDashboardById(this.props.match.params.dashboardId);
        let events = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
        this.props.selectedDashboard.events && this.props.selectedDashboard.events.map(event => {
            events[event.monthIndex] = event;
        })
        eventsData = events;
        //sync code is derived from https://asvd.github.io/syncscroll/syncscroll.js library
        const Width = 'Width';
        const Height = 'Height';
        const Top = 'Top';
        const Left = 'Left';
        const scroll = 'scroll';
        const client = 'client';
        const EventListener = 'EventListener';
        const addEventListener = 'add' + EventListener;
        const length = 'length';
        const Math_round = Math.round;

        const names = {};
        const reset = function () {
            const elems = document.getElementsByClassName('sync' + scroll);
            // clearing existing listeners
            let i, j, el, found, name;
            for (name in names) {
                if (names.hasOwnProperty(name)) {
                    for (i = 0; i < names[name][length]; i++) {
                        names[name][i]['remove' + EventListener](
                            scroll, names[name][i].syn, 0
                        );
                    }
                }
            }
            // setting-up the new listeners
            for (i = 0; i < elems[length];) {
                found = j = 0;
                el = elems[i++];
                if (!(name = el.getAttribute('name'))) {
                    // name attribute is not set
                    continue;
                }

                el = el["p-" + scroll + 'er'] || el;  // needed for intence

                // searching for existing entry in array of names;
                // searching for the element in that entry
                for (; j < (names[name] = names[name] || [])[length];) {
                    found |= names[name][j++] == el;
                }

                if (!found) {
                    names[name].push(el);
                }

                el.eX = el.eY = 0;

                (function (el, name) {
                    el[addEventListener](
                        scroll,
                        el.syn = function () {
                            var elems = names[name];

                            var scrollX = el[scroll + Left];
                            var scrollY = el[scroll + Top];

                            var xRate =
                                scrollX /
                                (el[scroll + Width] - el[client + Width]);
                            var yRate =
                                scrollY /
                                (el[scroll + Height] - el[client + Height]);

                            var updateX = scrollX != el.eX;
                            var updateY = scrollY != el.eY;

                            var otherEl, i = 0;

                            el.eX = scrollX;
                            el.eY = scrollY;

                            for (; i < elems[length];) {
                                otherEl = elems[i++];
                                if (otherEl != el) {
                                    if (updateX &&
                                        Math_round(
                                            otherEl[scroll + Left] -
                                            (scrollX = otherEl.eX =
                                                Math_round(xRate *
                                                    (otherEl[scroll + Width] -
                                                        otherEl[client + Width]))
                                            )
                                        )
                                    ) {
                                        otherEl[scroll + Left] = scrollX;
                                    }

                                    if (updateY &&
                                        Math_round(
                                            otherEl[scroll + Top] -
                                            (scrollY = otherEl.eY =
                                                Math_round(yRate *
                                                    (otherEl[scroll + Height] -
                                                        otherEl[client + Height]))
                                            )
                                        )
                                    ) {
                                        otherEl[scroll + Top] = scrollY;
                                    }
                                }
                            }
                        }, 0
                    );
                })(el, name);
            }
        }

        reset();

        const tracksW = this.tracksRef.current.offsetWidth;
        this.setState({
            tracksW
        });

    }

    onClickLeft = () => {
        this.tracksRef.current.scrollBy({
            // left: this.state.tracksW / 2,
            left: 200,
            behavior: 'smooth'
        });
    }

    onClickRight = () => {
        this.tracksRef.current.scrollBy({
            //left: -(this.state.tracksW / 2),
            left: -200,
            behavior: 'smooth'
        });
    }

    render() {
        let eventsTemp = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        this.props.selectedDashboard.events && this.props.selectedDashboard.events.map(event => {
            eventsTemp[event.monthIndex] = event;
        })
        eventsData = eventsTemp;

        const conceptsObjMap = new Map();
        if (this.props.selectedDashboard.concepts) {
            this.props.selectedDashboard.concepts.forEach((value, index) => {
                const monthIndex = value.monthIndex;
                const groupIndex = this.props.selectedDashboard.groups.findIndex(groupObj => groupObj._id === value.groupId);
                const conceptObjKey = `${monthIndex}-${groupIndex}`;
                conceptsObjMap.set(conceptObjKey, value);
            });
        }

        const events = eventsData;

        const monthsColumnsDisplayOnly = this.state.monthData.map((value, index) => {
            let style = {};

            if (index % 3) {
                style = {
                    backgroundColor: "#1e4471",
                    color: "#fff",
                }
            } else {
                style = {
                    backgroundColor: "#1e4471",
                    color: "#fff",
                    border: "1px solid #1A517D",
                    borderTop: "0px",
                    borderBottom: "0px",
                    borderRight: "0px"

                }
            }
            return (
                <div key={index} className="p-track">
                    <div className="p-heading" style={style} >{value}</div>
                </div>
            );
        });

        const quarterColumnsDisplayOnly = this.state.quarterData.map((value, index) => {
            const style = {
                backgroundColor: "#102d54",
                color: "#fff",
                border: "1px solid rgb(0, 188, 235)",
                borderBottom: "0px",
                borderRight: "0px"
            }
            return (
                <div key={index} className="p-track-quarter">
                    <div className="p-heading" style={style}>{value}</div>
                </div>
            );
        });

        const eventsColumnsDisplayOnly = eventsData && eventsData.map((value, index) => {

            let style = {};

            if (index % 3) {
                style = {
                    backgroundColor: "#102d54",
                }
            } else {
                style = {
                    backgroundColor: "#102d54",
                    border: "1px solid #1A517D",
                    borderTop: "0px",
                    borderBottom: "0px",
                    borderRight: "0px"
                }
            }

            if (value.name) {
                return (
                    <div key={index} className="p-track">
                        <div className="p-heading p-event" style={style}>
                            <div className="p-details p-event-detail" style={{ backgroundColor: "#00bceb", border: "0px" }}>
                                <h3 >
                                    <EllipsisTooltip
                                        name={value.name}
                                    />
                                </h3>
                                <p>{`${moment(value.startDate).format('DD-MM-YYYY')} - ${moment(value.endDate).format('DD-MM-YYYY')}`}</p>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div key={index} className="p-track">
                        <div className="p-heading p-event" style={style}>
                        </div>
                    </div>
                );
            }
        });

        const groupColumnsDisplayOnly = this.props.selectedDashboard.groups && this.props.selectedDashboard.groups.map((value, index) => {
            const className = `p-entry ${teamColors[index]}`;
            let style = {
                border: "1px solid #1A517D",
                borderTop: "0px",
                borderBottom: "0px",
                borderLeft: "0px"
            }

            if (index % 2) {
                style.background = "#1e4471";
            } else {
                style.background = "#102d54";
            }

            return (
                <div className={className} key={value._id} style={style}>
                    <div className="p-details p-group">
                        <h3 >
                            <EllipsisTooltip
                                name={value.name}
                                line={2}
                            />
                        </h3>
                        <ul>
                            {value && value.items && value.items.map((itm, i) => {
                                return <li key={i}>
                                    <EllipsisTooltip
                                        name={itm}
                                    />
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
            );
        });

        const getConceptComponentDisplayOnly = (monthIndex, groupIndex, event) => {
            const conceptObjKey = `${monthIndex}-${groupIndex}`;
            const conceptData = conceptsObjMap.get(conceptObjKey);
            let style = {};
            let conceptCardStyle = {
                color: "#ffffff",
                borderColor: "#1A517D"
            };

            if (monthIndex % 3) {
                style = {
                    border: "0px"
                }
            } else {
                style = {
                    backgroundColor: "#102d54",
                    border: "1px solid #1A517D",
                    borderTop: "0px",
                    borderBottom: "0px",
                    borderRight: "0px",
                    borderOpacity: 0.78
                }
            }

            if (groupIndex % 2 == 0) {
                style.background = "#1e4471";
                conceptCardStyle.background = "#102d54";
            } else {
                style.background = "#102d54";
                conceptCardStyle.background = "#1e4471";
            }

            if (conceptData) {
                const initiativesList = conceptData.initiatives.map((initiative, index) => {
                    return (
                        <div className="initiatve-card" key={index} style={conceptCardStyle}>
                            <div className="concept-name">
                                <EllipsisTooltip
                                    name={initiative}
                                    style={{
                                        width: "calc(100% - 20px)",
                                        float: "left"
                                    }}
                                />
                            </div>
                        </div>
                    );
                });

                return (
                    <div>
                        <div key={groupIndex} className="p-entry" style={style}>
                            <div className="concept-card" style={conceptCardStyle} >
                                <div className="concept-header" style={conceptCardStyle}>
                                    <EllipsisTooltip
                                        name={conceptData.name}
                                        style={{ width: "100%" }} />
                                </div>
                                <div groupName='initiatives' >
                                    {initiativesList}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div key={groupIndex} className="p-entry" style={style}>
                    </div>
                );
            }
        }

        const conceptColumnsDisplayOnly = this.state.monthData.map((value, monthIndex) => {
            if (eventsData) {
                const event = eventsData[monthIndex];
                return (
                    <div key={monthIndex} className="p-track">

                        {
                            this.props.selectedDashboard.groups && this.props.selectedDashboard.groups.map((value, groupIndex) => {
                                return <div key={value._id}>
                                    {getConceptComponentDisplayOnly(monthIndex, groupIndex, event)}
                                </div>
                            })
                        }

                    </div>
                );
            }
        });

        const { selectedAccount } = this.props;

        const styleLogo = {
            margin: "0 20px",
            height: "30px",
            filter: "brightness(0) invert(1)",
        }

        return (
            <div id="target">
                <div className="p-print-view-header">
                    <div className="p-dashboard-header event-logo">
                        <img style={styleLogo} src={selectedAccount && selectedAccount.logo ?
                            selectedAccount.logo : defaultLogo} alt='' />
                    </div>
                    <div className="p-dashboard-header event-name" style={{ color: "#fff" }}>
                        {this.props.selectedDashboard.name}
                    </div>
                    <div className="p-dashboard-header event-button">
                        <Button.Group className="event-toggle-button">
                            <Button className="f_11" onClick={this.props.history.goBack}>Edit</Button>
                            <Button className="f_11" onClick={this.saveToImage.bind(this)} >Export</Button>
                        </Button.Group>
                    </div>
                </div>
                <div className="p-table-modal">
                    <div className="p-table" style={{ border: "0px" }}>
                        <div className="p-headers p-first">
                            <div className="p-scroller syncscroll" name="myElements">
                                <div className="p-track p-time">
                                    <div className="p-heading" style={{ backgroundColor: "#102d54" }}></div>
                                </div>
                                {quarterColumnsDisplayOnly}
                            </div>
                        </div>
                        <div className="p-headers p-second">
                            <div className="p-buttons">
                                <div className="p-button left-button" style={{ background: "#0f2d54" }}>
                                    <Icon style={{ borderRadius: "4px" }} name='angle left' onClick={this.onClickRight} />
                                </div>
                                <div className="p-button right-button" style={{ background: "#0f2d54" }}>
                                    <Icon style={{ borderRadius: "4px" }} name='angle right' onClick={this.onClickLeft} />
                                </div>
                            </div>
                            <div className="p-scroller syncscroll" name="myElements">
                                <div className="p-track p-time">
                                    <div className="p-heading" style={{ backgroundColor: "#1e4471" }}></div>
                                </div>
                                {monthsColumnsDisplayOnly}
                            </div>
                        </div>
                        <div className="p-headers p-third">
                            <div className="p-scroller syncscroll" name="myElements">
                                <div className="p-track p-time">
                                    <div className="p-heading p-event" style={{
                                        color: "rgb(0, 188, 235)",
                                        backgroundColor: "#102d54",
                                        border: "1px solid #1A517D",
                                        borderTop: "0px",
                                        borderBottom: "0px",
                                        borderLeft: "0px"
                                    }}>Events</div>
                                </div>
                                {eventsColumnsDisplayOnly}
                            </div>
                        </div>
                        <div className="p-tracks syncscroll" name="myElements" ref={this.tracksRef}>
                            <div className="p-track p-time">
                                {groupColumnsDisplayOnly}
                            </div>
                            {conceptColumnsDisplayOnly}
                        </div>
                    </div>
                </div>
                <div id="top-of-site-pixel-anchor"></div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedDashboard: state.dashboards.selectedDashboard,
        selectedAccount: state.app.selectedAccount
    };
}

const connectedPrintViewPage = withRouter(connect(mapStateToProps)(PrintViewPage));
export { connectedPrintViewPage as PrintViewPage };